oyc.Scroll = {
  toTop: {
    selector: '#toTop',
    heightValue: 150,
    item: {}
  },
  init: function () {
    this.toTop.item = $(this.toTop.selector);
    $(window).scroll(this.toTopScrollEvents.bind(this));
  },
  toTopScrollEvents: function () {
    var height = $(window).scrollTop();
    if (height > this.toTop.heightValue) {
      this.toTop.item.fadeIn();
    } else {
      this.toTop.item.fadeOut();
    }
  },
}
